import { Directive, Input,  } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import moment from 'moment';

@Directive({
  selector: '[minDate]',
  providers: [{provide: NG_VALIDATORS, useExisting: MinDateDirective, multi: true}]
})
export class MinDateDirective implements Validator {

  constructor() { }

  @Input() minDate?:Date;

  validate(control: AbstractControl): ValidationErrors | null {

    const value = control.value;
    if ((value||'')==''){
      return null;
    }
    if (!this.minDate) return null;

      let fromDate=  moment().add(-1,'year').startOf('year').toDate(); 
      let toDate=  moment().add(-1,'year').endOf('year').toDate(); 
      if (moment(value).isBefore(this.minDate)){        
        return {'Errors/minDate':'La date doit être supérieure ou égale à ' + moment(this.minDate).format('DD/MM/YYYY')};
      }
      return null;
  }
}
